import { create } from "zustand";
import { persist } from "zustand/middleware";
// import {createJSONStorage} from "zustand/middleware";

const useAuthStore = create(
  persist(
    (set) => ({
      token: null,
      user: null,
      roles: null,
      company: null,
      testMode: null,

      setImpersonateToken: (value) =>
        set({
          token: value,
          user: null,
          roles: null,
          company: null,
          testMode: null,
        }),

      clearToken: () =>
        set({
          token: null,
          user: null,
          roles: null,
          company: null,
          testMode: null,
        }),
      setToken: (value) => set({ token: value, user: null }),
      setUserAuth: (value) => set({ ...value }),
      setUser: (value) => set({ user: value }),
      setRoles: (value) => set({ roles: value }),
      setCompany: (value) => set({ company: value }),
      setTestMode: (value) => set({ testMode: value }),
    }),
    {
      name: "x-auth", // name of item in the storage (must be unique)
      //storage: createJSONStorage(() => sessionStorage), // (optional) by default, 'localStorage' is used
      partialize: (state) => ({
        token: state.token,
        user: state.user,
        roles: state.roles,
        company: state.company,
      }),
    },
  ),
);

export default useAuthStore;
